import { ReactNode } from "react";
import { Theme } from "@mui/material/styles";
import Skeleton from "@mui/material/Skeleton";
import TableCell from "@mui/material/TableCell";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";

// The shared look of the แถวสรุปยอด row. Both รายงานการโอน tables — one row per สายส่ง and
// one per branch-day — close with a totals row, and they sit two clicks apart, so the weight,
// the rule above the row and the money alignment are defined once here.

/** The totals row itself: a rule above it, and no per-cell colour that could outrank an sx. */
export const TOTALS_ROW_SX = {
  bgcolor: (theme: Theme) => theme.palette.background.default,
  // No `color` here: a descendant selector would outrank the per-cell sx that paints
  // ผลต่าง red or green.
  "& td": {
    borderTop: "2px solid",
    borderTopColor: "divider",
    borderBottom: "none",
    fontSize: "0.95rem",
    padding: "10px 8px",
  },
} as const;

/** Every figure in the totals row is bold and must not wrap mid-number. */
export const totalsCellSx = { whiteSpace: "nowrap", fontWeight: 700 } as const;

export const TotalsMoneyCell = ({ children }: { children: ReactNode }) => (
  <TableCell align="right" sx={totalsCellSx}>
    {children}
  </TableCell>
);

/** Non-money counts (จำนวนสาย, จำนวนร้านค้า) are centred, like their column above. */
export const TotalsCountCell = ({ children }: { children: ReactNode }) => (
  <TableCell align="center" sx={totalsCellSx}>
    {children}
  </TableCell>
);

/**
 * The totals row while the page it totals is still loading. One cell across the whole table:
 * a skeleton per column would imply the figures are already laid out under their headers.
 */
export const TotalsSkeletonFooter = ({
  columnCount,
}: {
  columnCount: number;
}) => (
  <TableFooter>
    <TableRow>
      <TableCell colSpan={columnCount}>
        <Skeleton variant="text" height={32} />
      </TableCell>
    </TableRow>
  </TableFooter>
);
